import React from 'react';
import PropTypes from 'prop-types';
import { DOCUMENT_TYPE_PROPERTIES_LIST_QUERY } from '../queries';
import DocumentTypePropertyListItem from './DocumentTypePropertyListItem';
import { DOCUMENT_TYPE_PROPERTY_REMOVED } from '../subscriptions';
import { Card } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { documentTypePropertiesStore } from '../store';
import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import { useToast } from 'hooks/toasts/useToast';
import { useMemo } from 'react';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import useSubscription from 'hooks/apollo/useSubscription';

const DocumentTypePropertyListBrowser = ({ documentTypeId }) => {
  const addToast = useToast();
  const [t] = useTranslation();

  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: DOCUMENT_TYPE_PROPERTIES_LIST_QUERY,
        name: 'documentTypeProperties',
        variables: { documentTypeId }
      }
    }),
    [documentTypeId]
  );

  useSubscription(DOCUMENT_TYPE_PROPERTY_REMOVED, {
    onData: ({ data: { data }, client }) => {
      addToast(t('DocumentTypes.DocumentTypeProperty.DocumentTypePropertyRemoved'), 'success');
      client.cache.evict({
        id: `DocumentTypePropertyItem:{"documentTypeId":${data.documentTypePropertyRemoved.documentTypeId},"propertyId":${data.documentTypePropertyRemoved.propertyId}}`
      });
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'documentTypeProperties' });
      client.cache.gc();
    }
  });

  const columns = useMemo(
    () => [
      { name: 'code', caption: 'DocumentTypes.DocumentTypeProperty.PropertyCode' },
      { name: 'name', caption: 'DocumentTypes.DocumentTypeProperty.PropertyName' },
      { name: 'propertyType', caption: 'DocumentTypes.DocumentTypeProperty.PropertyType' },
      { name: 'defaultValue', caption: 'DocumentTypes.DocumentTypeProperty.DefaultValue' },
      { name: 'mandatory', caption: 'DocumentTypes.DocumentTypeProperty.Mandatory' },
      { name: 'implicit', caption: 'DocumentTypes.DocumentTypeProperty.Implicit' },
      { name: 'implicit', caption: 'DocumentTypes.DocumentTypeProperty.OrderNo' },
      { name: 'actions', caption: 'Actions', width: '120px' }
    ],
    []
  );

  return (
    <Card icon={ListAltIcon}>
      <TableListBrowser
        name='document-type-properties-browser'
        store={documentTypePropertiesStore}
        ItemComponent={DocumentTypePropertyListItem}
        columns={columns}
      />
      <ExportModalComponent store={documentTypePropertiesStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={documentTypePropertiesStore} options={fetchingOptions} />
    </Card>
  );
};

DocumentTypePropertyListBrowser.propTypes = {
  documentTypeId: PropTypes.number.isRequired
};

export default DocumentTypePropertyListBrowser;
